export default {
	LIMIT: 10,
}
